import { Check, X } from "lucide-react";

const RULES = [
  { k: "len", label: "8 caractères minimum", test: (p) => p.length >= 8 },
  { k: "upper", label: "1 majuscule", test: (p) => /[A-Z]/.test(p) },
  { k: "digit", label: "1 chiffre", test: (p) => /\d/.test(p) },
  { k: "special", label: "1 caractère spécial", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

const LEVELS = [
  { label: "Très faible", color: "bg-rose-500", text: "text-rose-600" },
  { label: "Faible", color: "bg-orange-500", text: "text-orange-600" },
  { label: "Moyen", color: "bg-amber-500", text: "text-amber-600" },
  { label: "Bon", color: "bg-lime-500", text: "text-lime-700" },
  { label: "Fort", color: "bg-emerald-600", text: "text-emerald-700" },
];

export const isStrongPassword = (p) => RULES.every((r) => r.test(p || ""));

const score = (p) => {
  const passed = RULES.filter((r) => r.test(p)).length;
  if (!p) return 0;
  return Math.min(4, passed - (passed === 4 && p.length < 12 ? 1 : 0));
};

export function PasswordStrength({ password = "" }) {
  const s = score(password);
  const lvl = LEVELS[s];
  return (
    <div className="mt-2 space-y-1.5" data-testid="password-strength">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className={`h-1.5 flex-1 rounded-full transition-colors duration-300 ${password && i <= Math.max(s, 1) ? lvl.color : "bg-slate-200"}`} />
        ))}
      </div>
      {password && <p className={`text-xs font-medium ${lvl.text}`} data-testid="password-strength-label">Force : {lvl.label}</p>}
      <ul className="grid grid-cols-2 gap-x-3 gap-y-0.5">
        {RULES.map((r) => {
          const ok = r.test(password);
          return (
            <li key={r.k} className={`flex items-center gap-1 text-[11px] ${ok ? "text-emerald-700" : "text-slate-500"}`} data-testid={`pw-rule-${r.k}`} data-ok={ok}>
              {ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}{r.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
